import Badge from 'common/Badge/Badge';
import BadgeList from 'common/Badge/BadgeList';

export { BadgeList };

export default Badge;
